import { Component, Input, OnInit } from '@angular/core';
import { PAYMENT_STATUS } from 'src/app/enums/payment-status.enum';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-order-card-info',
  templateUrl: './order-card-info.component.html',
  styleUrls: ['./order-card-info.component.css']
})
export class OrderCardInfoComponent implements OnInit {
  @Input() day: number;
  @Input() passType: string;
  @Input() typeName: string;
  @Input() quantity: number;
  @Input() isPaid: boolean;
  @Input() isPickup: boolean;
  @Input() numDay: number;
  @Input() isView: boolean;
  @Input() channel: string;
  @Input() set startDate(value) {
    this.__startDate = this.setDateFormat(value);
  };
  @Input() set endDate(value) {
    this.__endDate = this.setDateFormat(value);
  }
  @Input() totalPrice: number;
  @Input() set orderDate(value) {
    this._orderDate = value;
    this.__orderDate = this.setDateFormat(value);
  }
  @Input() set createdDate(value) {
    this._createdDate= value;
    this.__createdDate = this.setDateFormat(value);
  }

  @Input() paymentStatus: PAYMENT_STATUS;
  @Input() referenceID: string;
  @Input() code: string;

  _orderDate: Date | string;
  _createdDate: Date | string;

  private __startDate: Date | string;
  private __endDate: Date | string;
  private __orderDate: Date | string;
  private __createdDate: Date | string;

  readonly PAYMENT_STATUS = PAYMENT_STATUS;
  constructor(private utilityService: UtilityService) { }

  ngOnInit(): void {
  }

  setDateFormat(date: any) {
    return this.utilityService.setDate_dd_MMM_YYYY_Detail(date)
  }

  get startDate(): Date | string {
    return this.__startDate;
  }
  get endDate(): Date | string {
    return this.__endDate;
  }
  get orderDate(): Date | string {
    return this.__orderDate;
  }

  getTicketType(num_day: number) {
    let ticket: any;
    switch (num_day) {
      case 3: 
        ticket= "LABEL.THREE_DAYS"
        break;

      case 7: 
        ticket= "LABEL.SEVEN_DAYS"
        break;

      default:
        ticket= "LABEL.ONE_DAY"
        break;
    }

    return ticket
  }
  get createdDate(): Date | string {
    return this.__createdDate;
  }
}
